<template>
  <tr :class="isPriceDifferenceHighlighted ? `price-difference` : null">
    <td :class="align ? `align-${align}` : null" class="label">{{ label }}</td>
    <td class="align-right">
      {{ discountPercentage ? discountPercentage + '%' : null }}
    </td>
    <td class="align-right">
      {{ discountAmount ? i18n.n(discountAmount, 'number') : null }}
    </td>
    <td class="align-right">
      {{ vwpfs !== null ? i18n.n(vwpfs, 'number') : null }}
    </td>
    <td class="align-right">
      {{ cst !== null ? i18n.n(cst, 'number') : null }}
    </td>
    <td class="align-right">
      {{
        alwaysShowDifference || (vwpfs !== null && cst !== null)
          ? i18n.n(priceDifference, 'number')
          : null
      }}
    </td>
  </tr>
</template>

<script>
export default {
  props: {
    align: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: '',
    },
    discountPercentage: {
      type: Number,
      default: null,
    },
    discountAmount: {
      type: Number,
      default: null,
    },
    vwpfs: {
      type: Number,
      default: null,
    },
    cst: {
      type: Number,
      default: null,
    },
    alwaysShowDifference: {
      type: Boolean,
      default: false,
    },
    minDifferenceHighlight: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
  computed: {
    priceDifference() {
      return (this.vwpfs !== null ? this.vwpfs : 0) - (this.cst !== null ? this.cst : 0)
    },
    isPriceDifferenceHighlighted() {
      if (!this.minDifferenceHighlight) return false

      return Math.abs(this.priceDifference) >= this.minDifferenceHighlight
    },
  },
}
</script>

<style lang="scss" scoped>
.label {
  white-space: nowrap;
}
.align {
  &-left {
    text-align: left;
  }
  &-center {
    text-align: center;
  }
  &-right {
    text-align: right;
  }
}
.price-difference {
  background-color: $color-danger;
}
</style>
